import {styled} from "@mui/material/styles"
import {SectionTitle} from "../../HomePageStyles";

export const GenericSectionWrapper = styled('div')`
	width: 100%;
	font-size: 1.2rem;
	line-height: 1.6;
	padding-left: 1rem;
	padding-right: 1rem;
	padding-top: 2rem;
	padding-bottom: 1.5rem;
	
`

export const Title= SectionTitle;

export const Content = styled('div')`
	padding-top: 1rem;
	line-height: 1.6;
`;
